module.exports = __webpack_public_path__ + "img/SIS-redblue-curves.1b5a5fad.svg";